import { MouseEvent, useCallback, useState } from 'react';

export function useAnchor<Element extends HTMLElement = HTMLElement>() {
  const [element, setElement] = useState<Element | null>(null);
  const open = Boolean(element);
  const onOpen = useCallback((event: MouseEvent<Element>) => {
    setElement(event.currentTarget);
  }, []);
  const onClose = useCallback(() => {
    setElement(null);
  }, []);

  return {
    open,
    element,
    onOpen,
    onClose,
  };
}
